import React, { useContext, useState, useEffect } from "react";
import PaginationCommand from "../PaginationCommand/PaginationCommand";
import { store } from "../../../store.js";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import useKeyPress from "../../../Hooks/useKeyPress";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function SearchGrid(props) {
  const buildStyle = useBuildStyle();
  
  /*const [actualWidth, actualHeight] = useSize(props.style.width, props.style.height, props.data.id);
    
  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);*/



 
  const getStyle = () => {
    var newStyle = buildStyle(props.style);
    //newStyle["left"] = props.data.parent.styles.left;
    //newStyle["top"] = props.data.top ;
    //newStyle["width"] = props.data.parent.styles.width;
    const border =  props.draggable && props.isSelected
    ? "1px dashed gray"
    : props.style.border.value
    
    newStyle["border"] = undefined
    newStyle["borderTop"] = "none";
    newStyle["borderLeft"] = "none";
    newStyle["borderRight"] = "none";
    newStyle["borderBottom"] = border;
    if (!props.draggable) newStyle["resize"] = "none"
    return newStyle;
  };
  
  return (
    <div onClick={(e) => props.onClick(e, props.data)} style={getStyle()}>
        
        <DropDownListNew
          fontSize={props.style.fontSize.value}
          currentData={props.data.allColums}
          id={"Filter" + props.data.id}
          multiSelection={true}
          searchIcon={true}
          selectedValues={props.data.selectedValues}
          onDropDownItemClick={(itemSelected) =>
            props.onMultiselectionClick(itemSelected)
          }
        onlyLabel={false}/>
      
        <div style={{ marginLeft: "auto", display: "flex" }}>
          <PaginationCommand  
            pagination ={props.data.pagination}
            onClickPagination ={(pagination) => props.onClickPagination(pagination)}
          />
        </div>
        
    </div>
  );
}
